import ContractsMileageUpdateRequest from "../../../../api/raily/contracts/mileage/update/contracts-mileage-update.request";
import ContractsMileageUpdateParams from "./contracts-mileage-update-params";

const create = (
  params: ContractsMileageUpdateParams,
): ContractsMileageUpdateRequest => {
  return {
    contractUuid: params.contractUuid,
    dietFullAfterHours: params.dietFullAfterHours,
    dietFullRate: params.dietFullRate,
    dietHalfAfterHours: params.dietHalfAfterHours,
    dietHalfRate: params.dietHalfRate,
    isActive: params.isActive,
    distanceRateCarGt900cm3: params.distanceRateCarGt900cm3,
    distanceRateCarLe900cm3: params.distanceRateCarLe900cm3,
    distanceRateCompanyVehicle: params.distanceRateCompanyVehicle,
    distanceRateMoped: params.distanceRateMoped,
    distanceRateMotorcycle: params.distanceRateMotorcycle,
    validSince: params.validSince,
    validTo: params.validTo,
  };
};

const contractsMileageUpdateParamsFactory = {
  create,
};

export default contractsMileageUpdateParamsFactory;
